const Home = () => (
  <>
    <div className="text-white py-3 px-5">
      <h4 className="text-white">Home</h4>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex rerum, quam
        nisi repellendus inventore at assumenda eaque distinctio illum nulla
        sapiente fuga aspernatur consequatur exercitationem, vero rem adipisci
        odio labore aliquid incidunt? Aspernatur necessitatibus doloremque
        laborum at sunt enim iure? Nesciunt, molestias. Sequi distinctio odio
        ipsa soluta accusantium tenetur excepturi alias iusto omnis corrupti,
        facilis libero beatae pariatur iure? Quam, quas ea! Fugiat, dolore.
      </p>

      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima
        voluptatum officia consequuntur, enim vel alias modi ipsum repudiandae
        inventore quisquam molestias voluptas odit ipsa numquam? Voluptatibus
        totam porro fugiat unde pariatur. Consequatur, expedita distinctio cum
        doloribus accusamus amet voluptatibus doloremque iure enim tempora
        explicabo? Nulla ducimus explicabo debitis eveniet ad facere dolorem
        exercitationem similique quo modi tenetur perspiciatis id quaerat,
        quidem amet recusandae vero?
      </p>
    </div>
  </>
);

export default Home;
